class Goose {
  honk() {
    console.log("Honk!");
  }
}

export default Goose;
